import {useEffect} from "react";
import {PLAN_TYPE_IDS} from "../Utils/PlanUtils";

const useResetPlan2PlanType = (state) => {
    useEffect(() => {
        if (state.plan2.planTypeID !== state.plan.planTypeID) {
            if (state.plan2.planTypeID !== PLAN_TYPE_IDS.TRANSFER) {
                state.setPlan2(prevData => ({...prevData, planTypeID: -1}));
            }
        }
    }, [state.plan.planTypeID]);

    //If the first plan gets set to a T mode in the group plan, the second plan should be reset
    useEffect(() => {
        if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP && state.plan.depositMode === 'T') {
            state.setPlan2(prevData => ({...prevData, planTypeID: -1}));
        }
    }, [state.plan.planTypeID, state.plan.depositMode]);
}

export default useResetPlan2PlanType;